export default __webpack_public_path__ + "static/media/Fiery Waltz.739547da.png";